import { trackingService } from '../../tracking';
import { TrackerType } from '../enums';
import { PRODUCT_NAME, PARTNER_ID } from './constants';

export const trackHistoryPageView = (userId?: string): void => {
  trackingService.trackEvent(
    'HISTORY',
    PRODUCT_NAME,
    {
      page: 'histórico',
      route: '/inicio/historico',
      placement: '',
      surface: '',
      flow: 'histórico receitas',
      step: 'listagem',
      element: '',
      action: 'view',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackHistoryCancelPrescriptionClick = (userId?: string): void => {
  trackingService.trackEvent(
    'CANCEL',
    PRODUCT_NAME,
    {
      page: 'histórico',
      route: '',
      placement: 'main',
      surface: 'list',
      flow: 'histórico receitas',
      step: 'cancelar receita',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackHistoryDetailsClick = (userId?: string): void => {
  trackingService.trackEvent(
    'DETAILS',
    PRODUCT_NAME,
    {
      page: 'histórico',
      route: '',
      placement: 'main',
      surface: 'list',
      flow: 'histórico receitas',
      step: 'ver detalhes',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackHistoryCleanFiltersClick = (userId?: string): void => {
  trackingService.trackEvent(
    'CLEAN',
    PRODUCT_NAME,
    {
      page: 'histórico',
      route: '',
      placement: 'main',
      surface: '',
      flow: 'histórico receitas',
      step: 'limpar filtros',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackHistoryApplyFiltersClick = (userId?: string): void => {
  trackingService.trackEvent(
    'APPLY',
    PRODUCT_NAME,
    {
      page: 'histórico',
      route: '',
      placement: 'main',
      surface: 'dialog',
      flow: 'histórico receitas',
      step: 'aplicar filtros',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackHistoryBackClick = (userId?: string): void => {
  trackingService.trackEvent(
    'BACK',
    PRODUCT_NAME,
    {
      page: 'histórico',
      route: '',
      placement: 'main',
      surface: 'dialog',
      flow: 'histórico receitas',
      step: 'voltar',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackHistoryDetailsPageView = (userId?: string, prescriptionId?: string): void => {
  trackingService.trackEvent(
    'DETAILS',
    PRODUCT_NAME,
    {
      page: 'detalhe receita',
      route: '/inicio/historico/detalhes',
      placement: '',
      surface: '',
      flow: 'histórico receitas',
      step: 'visualizar detalhes',
      element: '',
      action: 'view',
      user_id: userId || '',
      prescription_id: prescriptionId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackHistoryDetailsCancelClick = (userId?: string): void => {
  trackingService.trackEvent(
    'CANCEL',
    PRODUCT_NAME,
    {
      page: 'detalhe receita',
      route: '',
      placement: 'main',
      surface: '',
      flow: 'histórico receitas',
      step: 'cancelar receita',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackHistoryDetailsCancelDialogBackClick = (userId?: string): void => {
  trackingService.trackEvent(
    'BACK',
    PRODUCT_NAME,
    {
      page: 'detalhe receita',
      route: '',
      placement: 'main',
      surface: 'dialog',
      flow: 'histórico receitas',
      step: 'voltar',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackHistoryDetailsCancelDialogConfirmClick = (userId?: string): void => {
  trackingService.trackEvent(
    'CANCEL',
    PRODUCT_NAME,
    {
      page: 'detalhe receita',
      route: '',
      placement: 'main',
      surface: 'dialog',
      flow: 'histórico receitas',
      step: 'confirmar cancelamento',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};
